import {FrameMeta} from "./problem-domain/frame";
import {Sentence, Span} from "./problem-domain/verb";

export function groupBy<T>(sentences: T[],
                           key: (s: T) => string): Map<string, T[]> {
    const result = new Map<string, T[]>();
    for (const sentence of sentences) {
        const pattern = key(sentence);
        let pattern_list = result.get(pattern);
        if (pattern_list === undefined) {
            pattern_list = [];
            result.set(pattern, pattern_list);
        }
        pattern_list.push(sentence);
    }
    return result;
}

function patternExtractor(sentence: Sentence): string {
    return sentence
        .map((span) => span.role)
        .filter((role) => role !== undefined)
        .join(",");
}

function constructionExtractor(sentence: Sentence): string {
    return sentence
        .map((span) => span.role)
        .filter((role) => role !== undefined && role.startsWith("*"))
        .join(",");
}

export function groupByPattern(sentences: Sentence[]): Map<string, Sentence[]> {
    return groupBy(sentences, patternExtractor);
}

export function groupByConstruction(sentences: Sentence[]): Map<string, Sentence[]> {
    return groupBy(sentences, constructionExtractor);
}

function patternToString(pattern: string[], count: number, totalCount: number) {
    return `%%PATTERN: ${pattern.map(x => `[${x}]`).join("-")}(${count}/${totalCount})`;
}


function formatGroupedSentence(pattern: string[], sentences: Sentence[],
                               sentenceTotalCount: number) {
    const patternString = patternToString(pattern, sentences.length, sentenceTotalCount);
    return patternString + "\r\n" + sentences.map(x => x.stringRepr()).join("\r\n") + "\r\n";
}

function formatSuperGroupSentence(construction: string[],
                                  sentences: Sentence[], sentenceTotalCount: number) {
    const constructionCount = sentences.length;
    const constructionString = `%%CONSTRUCTION: ${construction.map(x => `[${x}]`).join("-")}(${constructionCount}/${sentenceTotalCount})`;
    return constructionString + "\r\n" + groupSentencesToFile(sentences);
}

export function superGroupSentencesToFile(sentences: Sentence[]) {
    const grouped = groupByConstruction(sentences);
    return Array.from(grouped.entries())
        .map(([construction, sentencesSubset]) => formatSuperGroupSentence(construction.split(","), sentencesSubset, sentences.length))
        .join("\r\n") + "\r\n";

}

export function groupSentencesToFile(sentences: Sentence[],
                                     cmp = (a, b) => b[1].length - a[1].length): string {
    const grouped = groupByPattern(sentences);
    return Array.from(grouped.entries())
        .sort(cmp)
        .map(([pattern, sentencesSubset]) => formatGroupedSentence(
            pattern.split(","), sentencesSubset, sentences.length))
        .join("\r\n") + "\r\n";
}

interface LinkNode {
    name: string,
    link: string | null
}

export function pathToLinks(path: string[], frameIndex: FrameMeta,
                            isLexicon: boolean): LinkNode[] {
    const items: LinkNode[] = [];
    let iFrameMeta = frameIndex;
    let end = isLexicon ? path.length - 1 : path.length;
    for (let i = 0; i < end; i++) {
        let value = path[i];
        iFrameMeta = iFrameMeta.sub_frames.filter(frame => frame.name == value)[0];
        if (iFrameMeta.def) {
            items.push({
                name: iFrameMeta.name,
                link: "/frame/" + path.slice(0, i + 1).join("/")
            });
        } else {
            items.push({
                name: iFrameMeta.name,
                link: null
            });
        }
    }
    if (isLexicon) {
        items.push({
            name: path.slice(-1)[0],
            link: "/lexicon/" + path.join("/")
        });
    }
    return items;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/tagUtils.ts